import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import { BaseIcon } from "../base-icon";
export var SpecsIcon = function(_param) /*#__PURE__*/ {
    var color = _param.color, _size = _param.size, size = _size === void 0 ? 16 : _size, props = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    return _jsx(BaseIcon, _object_spread_props(_object_spread({}, props), {
        color: color,
        height: size,
        width: size,
        children: /*#__PURE__*/ _jsx("path", {
            fill: "currentColor",
            d: "M9.067 5.052a2.56 2.56 0 0 1 .507-3.047l.398-.377a3.108 3.108 0 0 1 3.648-.458l-1.927 1.824a.932.932 0 0 0 1.28 1.354l1.928-1.824a3.108 3.108 0 0 1-.658 3.616l-.398.377a2.56 2.56 0 0 1-3.07.34l-8.19 7.752a1.242 1.242 0 1 1-1.709-1.805l8.19-7.752Z"
        })
    }));
};
